import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Loader from "../components/Loader";
import CanvasJSReact from "@canvasjs/react-charts";
import { FormControl } from "@material-ui/core";
import dashimg from "../assets/dashboard banner.png";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import toast from "react-hot-toast";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";
import IssueNumberService from "../services/IssueNumberService";
import WarehouseMasterService from "../services/WarehouseMasterService";
import DashboardService from "../services/DashboardService";
import { useBrand } from "./../helper/BrandContext";
import { Skeleton } from "@mui/material";
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const Home = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const issueNumberService = new IssueNumberService();
  const warehouseMasterService = new WarehouseMasterService();
  const dashboardService = new DashboardService();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [summaryLoading, setSummaryLoading] = useState(true);
  const [monthlyShipperLoading, setMonthlyShipperLoading] = useState(true);
  const [productActivationLoading, setProductActivationLoading] =
    useState(true);
  const [regionIdWeekly, setRegionIdWeekly] = useState(0);
  const [regionIdMonthly, setRegionIdMonthly] = useState(0);
  const [UniqueregionIdWeekly, setUniqueRegionIdWeekly] = useState(0);
  const [UniqueregionIdMonthly, setUniqueRegionIdMonthly] = useState(0);
  const [warehouseId, setwarehouseId] = useState(0);
  const [statesMonthly, setStatesMonthly] = useState("");
  const [statesWeekly, setStatesWeekly] = useState("");

  const [statesWeeklyUnique, setStatesWeeklyUnique] = useState("");
  const [statesMonthlyUnique, setStatesMonthlyUnique] = useState("");
  const [lineTypeId, setlineTypeId] = useState(0);
  const [warehouseIdActivation, setwarehouseIdActivation] = useState(0);
  const [productIdActivation, setproductIdActivation] = useState();
  const [warehouses, setWarehouses] = useState([]);
  const [products, setProducts] = useState(0);
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [isUniqueCardVisible, setIsUniqueCardVisible] = useState(false);
  const [userType, setUserType] = useState(sessionStorage.getItem("userType"));
  const [userWarehouse, setuserWarehouse] = useState(
    sessionStorage.getItem("wareHouseId")
  );
  const [data, setData] = useState({
    totalActivated: null,
    totalScansAttempted: null,
    verified: null,
    fake: null
  });
  const [totals, setTotals] = useState({
    TotalPacking: 0,
    TotalWeeklyScans: 0,
    TotalMonthlyScans: 0,
    TotalWeeklyScansUnique: 0,
    TotalMonthlyScansUnique: 0,
    TotalActivations: 0,
    states: ""
  });
  const [chartOptionsPacking, setchartOptionsPacking] = useState({});
  const [chartOptionsActivations, setchartOptionsActivations] = useState({});
  const [chartOptionsweekly, setchartOptionsweekly] = useState({});
  const [chartOptionsmonthly, setchartOptionsmonthly] = useState({});
  const [chartUniqueOptionsweekly, setUniquechartOptionsweekly] = useState({});
  const [chartUniqueOptionsmonthly, setUniquechartOptionsmonthly] = useState({});
  useEffect(() => {
    //setLoading(true);
    if (brand) {
      GetProducts(brand);
      fetchWarehouseOptions(brand);
      setRegionIdWeekly(0);
      setRegionIdMonthly(0);
      setUniqueRegionIdWeekly(0);
      setUniqueRegionIdMonthly(0);
      MonthlyVerificationCount(0, brand);
      weeklyVerificationCount(0, brand);
      UniqueMonthlyVerificationCount(0, brand);
      UniqueweeklyVerificationCount(0, brand);
      fetchData(["", ""], brand);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [brand]);

  const [value, setValue] = useState(["", ""]);

  const [state, setState] = useState({
    regions: [
      { id: 0, value: "All" },
      { id: 3, value: "North" },
      { id: 1, value: "East" },
      { id: 4, value: "South" },
      { id: 2, value: "West" },
      { id: 5, value: "Other" }
    ],
    lineType: [
      { id: 0, value: "Last 7 Days" },
      { id: 2, value: "Last 30 Days" },
      { id: 1, value: "Last 12 Months" }
    ]
  });

  const toggleCardVisibility = () => {
    setIsCardVisible((prevState) => !prevState);

  };
  const toggleUniqueCardVisibility = () => {
    setIsUniqueCardVisible((prevState) => !prevState);
  };

  const fetchWarehouseOptions = async (brand) => {
    try {
      warehouseMasterService.GetWarehouseDDL().then((response) => {
        if (response && response.responseCode == "200") {
          const data = response.responseData;
          setWarehouses(data);
          if (userType == "0") {
            let newItem = { label: "All", value: "0" };
            data.unshift(newItem);
            setWarehouses(data);
          } else {
            data = data.filter((item) => item.value == userWarehouse);
            setWarehouses(data);
          }
          setwarehouseId(data[0].value);
          setwarehouseIdActivation(data[0].value);
          MonthlyPackingCount(data[0].value, brand);
          MonthlyActivationCount(data[0].value, [0], 0, brand);
        } else {
          toast.error(
            response.responseMessage || "Failed to fetch warehouse options"
          );
        }
      });
    } catch (error) {
      //console.error('Failed to fetch warehouse options:', error);
      //toast.error('Failed to fetch warehouse options');
    }
  };

  function GetProducts(brandId) {
    issueNumberService.getproducts(brandId).then((response) => {
      if (response && response.responseCode == "200") {
        const data = response.responseData;
        if (data.length > 0) {
          setProducts(data);
        }
      } else {
        setProducts([]);
      }
    });
  }

  const fetchData = async (values, brandId) => {
    setSummaryLoading(true);
    brandId = brandId ? brandId : brand;
    try {
      if (values[0] !== "" && values[1] !== "") {
        dashboardService
          .GetVerificationCounts(
            values[0].toLocaleDateString(),
            values[1].toLocaleDateString(),
            brandId
          )
          .then((response) => {
            if (response && response.responseCode == "200") {
              const data = response.responseData;
              setData({
                totalActivated: data[0].totalActivated,
                totalScansAttempted: data[0].totalScansAttempted,
                verified: data[0].verifiedAuth,
                fake: data[0].fakeAuth
              });
              setSummaryLoading(false);
            } else {
              setData({
                totalActivated: 0,
                totalScansAttempted: 0,
                verified: 0,
                fake: 0
              });
              setSummaryLoading(false);
            }
          });
      } else {
        dashboardService
          .GetVerificationCounts("", "", brandId)
          .then((response) => {
            if (response && response.responseCode == "200") {
              const data = response.responseData;
              setData({
                totalActivated: data[0].totalActivated,
                totalScansAttempted: data[0].totalScansAttempted,
                verified: data[0].verifiedAuth,
                fake: data[0].fakeAuth
              });
              setSummaryLoading(false);
            } else {
              setData({
                totalActivated: 0,
                totalScansAttempted: 0,
                verified: 0,
                fake: 0
              });
              setSummaryLoading(false);
            }
          });
      }
    } catch (error) {
      //console.error('Error fetching authentication stats', error);
    }
  };

  const MonthlyVerificationCount = async (value, brand) => {
    setRegionIdMonthly(value);
    const selectedRegionId = value;
    try {
      dashboardService
        .GetMonthlyVerificationCountsRegionWise(selectedRegionId, brand)
        .then((response) => {
          if (response && response.responseCode == "200") {
            const data = response.responseData;
            setStatesMonthly(data[0].states);
            // Map the response data to chart data points
            const genuineDataPoints = data.map((item) => ({
              label: item.month,
              y: parseInt(item.genuineCount, 10) // Convert string to number
            }));

            const fakeDataPoints = data.map((item) => ({
              label: item.month,
              y: parseInt(item.fakeCount, 10) // Convert string to number
            }));

            const total = data.reduce(
              (sum, item) =>
                sum + parseInt(item.genuineCount) + parseInt(item.fakeCount),
              0
            );

            setTotals((prevData) => ({
              ...prevData,
              TotalMonthlyScans: total
            }));

            // Update the chart options with the new data
            setchartOptionsmonthly({
              height: 150,
              axisY: {
                gridThickness: 1,
                gridColor: "#b4b4b4",
                lineColor: "d6d6d6"
              },
              axisX: {
                interval: 1
              },
              data: [
                {
                  type: "column",
                  name: "Authentic",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#0f9ed5",
                  dataPoints: genuineDataPoints
                },
                {
                  type: "column",
                  name: "Invalid",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#ed2225",
                  dataPoints: fakeDataPoints,
                  barSpacing: 15
                }
              ]
            });
          } else {
            setStatesMonthly("");
          }
        });
    } catch (error) {
      //console.error('Error fetching data:', error);
    }
  };

  const weeklyVerificationCount = async (value, brand) => {
    setRegionIdWeekly(value);
    const selectedRegionId = value;
    try {
      dashboardService
        .GetWeeklyVerificationCountsRegionWise(selectedRegionId, brand)
        .then((response) => {
          if (response && response.responseCode == "200") {
            const data = response.responseData;
            setStatesWeekly(data[0].states);

            // Map the response data to chart data points
            const weeklyDataPoints = data.map((item) => ({
              label: item.week,
              y: parseInt(item.authentic, 10) // Convert string to number
            }));

            const ValidAuth = data.map((item) => ({
              label: item.week,
              y: parseInt(item.fake, 10) // Convert string to number
            }));

            const total = data.reduce(
              (sum, item) =>
                sum + parseInt(item.authentic) + parseInt(item.fake),
              0
            );

            setTotals((prevData) => ({
              ...prevData,
              TotalWeeklyScans: total
            }));

            // Update the chart options with the new data
            setchartOptionsweekly({
              height: 150,
              axisY: {
                gridThickness: 1,
                gridColor: "#b4b4b4",
                lineColor: "d6d6d6"
              },
              axisX: {
                interval: 1
              },
              data: [
                {
                  type: "column",
                  name: "Authentic",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#0f9ed5",
                  dataPoints: weeklyDataPoints
                },
                {
                  type: "column",
                  name: "Invalid",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#ed2225",
                  dataPoints: ValidAuth
                }
              ]
            });
          } else {
            setStatesWeekly("");
          }
        });
    } catch (error) {
      //console.error('Error fetching data:', error);
    }
  };


  const MonthlyPackingCount = async (value, brand) => {
    setMonthlyShipperLoading(true);
    setwarehouseId(value);
    try {
      dashboardService
        .GetMonthlyPackingCounts(value, brand)
        .then((response) => {
          if (response && response.responseCode == "200") {
            const data = response.responseData;

            // Map the response data to chart data points
            const monthlydata = data.map((item) => ({
              label: item.month,
              y: parseInt(item.count, 10) // Convert string to number
            }));

            const total = data.reduce(
              (sum, item) => sum + parseInt(item.count),
              0
            );

            setTotals((prevData) => ({
              ...prevData,
              TotalPacking: total
            }));

            // Update the chart options with the new data
            setchartOptionsPacking({
              height: 150,
              axisY: {
                gridThickness: 1,
                gridColor: "#b4b4b4",
                lineColor: "d6d6d6"
              },
              axisX: {
                interval: 1
              },
              data: [
                {
                  type: "column",
                  name: "Scan Count",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#519c65",
                  dataPoints: monthlydata
                }
              ]
            });
            setMonthlyShipperLoading(false);
          }
        });
    } catch (error) {
      setMonthlyShipperLoading(false);
      //console.error('Error fetching data:', error);
    }
  };

  const UniqueweeklyVerificationCount = async (value, brand) => {
    setUniqueRegionIdWeekly(value);
    const selectedRegionId = value;
    try {
      dashboardService
        .GetUniqueWeeklyVerificationCountsRegionWise(selectedRegionId, brand)
        .then((response) => {
          if (response && response.responseCode == "200") {
            const data = response.responseData;
            setStatesWeeklyUnique(data[0].states);

            // Map the response data to chart data points
            const weeklyDataPoints = data.map((item) => ({
              label: item.week,
              y: parseInt(item.authentic, 10) // Convert string to number
            }));

            const ValidAuth = data.map((item) => ({
              label: item.week,
              y: parseInt(item.fake, 10) // Convert string to number
            }));

            const total = data.reduce(
              (sum, item) =>
                sum + parseInt(item.authentic) + parseInt(item.fake),
              0
            );

            setTotals((prevData) => ({
              ...prevData,
              TotalWeeklyScansUnique: total
            }));

            // Update the chart options with the new data
            setUniquechartOptionsweekly({
              height: 150,
              axisY: {
                gridThickness: 1,
                gridColor: "#b4b4b4",
                lineColor: "d6d6d6"
              },
              axisX: {
                interval: 1
              },
              data: [
                {
                  type: "column",
                  name: "Authentic",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#0f9ed5",
                  dataPoints: weeklyDataPoints
                },
                {
                  type: "column",
                  name: "Invalid",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#ed2225",
                  dataPoints: ValidAuth
                }
              ]
            });
          } else {
            setStatesWeeklyUnique("");
          }
        });
    } catch (error) {
      //console.error('Error fetching data:', error);
    }
  };

  const UniqueMonthlyVerificationCount = async (value, brand) => {
    setUniqueRegionIdMonthly(value);
    const selectedRegionId = value;
    try {
      dashboardService
        .GetUniqueMonthlyVerificationCountsRegionWise(selectedRegionId, brand)
        .then((response) => {
          if (response && response.responseCode == "200") {
            const data = response.responseData;
            setStatesMonthlyUnique(data[0].states);
            // Map the response data to chart data points
            const genuineDataPoints = data.map((item) => ({
              label: item.month,
              y: parseInt(item.genuineCount, 10) // Convert string to number
            }));

            const fakeDataPoints = data.map((item) => ({
              label: item.month,
              y: parseInt(item.fakeCount, 10) // Convert string to number
            }));

            const total = data.reduce(
              (sum, item) =>
                sum + parseInt(item.genuineCount) + parseInt(item.fakeCount),
              0
            );

            setTotals((prevData) => ({
              ...prevData,
              TotalMonthlyScansUnique: total
            }));

            // Update the chart options with the new data
            setUniquechartOptionsmonthly({
              height: 150,
              axisY: {
                gridThickness: 1,
                gridColor: "#b4b4b4",
                lineColor: "d6d6d6"
              },
              axisX: {
                interval: 1
              },
              data: [
                {
                  type: "column",
                  name: "Authentic",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#0f9ed5",
                  dataPoints: genuineDataPoints
                },
                {
                  type: "column",
                  name: "Invalid",
                  showInLegend: true,
                  dataPointWidth: 30,
                  indexLabelPlacement: "outside",
                  color: "#ed2225",
                  dataPoints: fakeDataPoints,
                  barSpacing: 15
                }
              ]
            });
          } else {
            setStatesMonthlyUnique("");
          }
        });
    } catch (error) {
      //console.error('Error fetching data:', error);
    }
  };


  const MonthlyActivationCount = async (
    warehouseId,
    productIds,
    type,
    brand
  ) => {
    setProductActivationLoading(true);
    try {
      let selectedProducts = [];
      if (productIds == undefined || productIds.length == 0) {
        selectedProducts.push({ id: 0 });
      } else {
        productIds.forEach((element) => {
          selectedProducts.push({ id: element });
        });
      }

      const Object = {
        warehouseId: warehouseId,
        products: selectedProducts,
        type: type,
        brandId: brand
      };

      dashboardService
        .GetMonthlyProductActivationCounts(Object)
        .then((response) => {
          if (response && response.responseCode == "200") {
            const data = response.responseData;

            // Map the response data to chart data points
            const monthlydata = data.map((item) => ({
              label: item.month,
              y: parseInt(item.count, 10) // Convert string to number
            }));

            const total = data.reduce(
              (sum, item) => sum + parseInt(item.count),
              0
            );

            setTotals((prevData) => ({
              ...prevData,
              TotalActivations: total
            }));

            // Update the chart options with the new data
            setchartOptionsActivations({
              height: 150,
              animationEnabled: true,
              axisX: {
                valueFormatString: "MMM"
              },
              axisY: {},
              data: [
                {
                  xValueFormatString: "MMMM",
                  type: "spline",
                  dataPoints: monthlydata
                }
              ]
            });
            setProductActivationLoading(false);
          } else {
            setProductActivationLoading(false);
          }
        });
    } catch (error) {
      setProductActivationLoading(false);
      //console.error('Error fetching data:', error);
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="container-fluid">
            <div className="row mt-3">
              <div className="col-md-5">
                <div className="cards authcountcard1">
                  <div className="container-fluid">
                    <div className="text-right">
                      <DateRangePicker
                        onChange={(values) => {
                          setValue(values);
                          fetchData(values);
                        }}
                        value={value}
                      />
                    </div>
                    <div
                      className="row mt-4 tttt"
                      style={{ marginTop: "2.5rem !important" }}
                    >
                      <div className="col-md-2 total_iconscol colwidthmobileone">
                        <i className="bi bi-shop-window"></i>
                      </div>
                      <div className="col-md-8 authentication_n colwidthmobiletwo">
                        <b>Total Activations at Plant</b>
                      </div>
                      <div className="col-md-2 n_issuencol colwidthmobilethree">
                        <h4>
                          {summaryLoading ? (
                            <Skeleton animation="wave" />
                          ) : data.totalActivated !== null ? (
                            data.totalActivated
                          ) : (
                            <Skeleton animation="wave" />
                          )}
                        </h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-2 valid_iconscol colwidthmobileone">
                        <i className="bi bi-check"></i>
                      </div>
                      <div className="col-md-8 authentication_n colwidthmobiletwo">
                        <b>Number of Scan Attempts</b>
                      </div>
                      <div className="col-md-2 mapping_ncol colwidthmobilethree">
                        <h4>
                          {summaryLoading ? (
                            <Skeleton animation="wave" />
                          ) : data.totalScansAttempted !== null ? (
                            data.totalScansAttempted
                          ) : (
                            <Skeleton animation="wave" />
                          )}
                        </h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-2 verified_iconscol n_issue_ic colwidthmobileone">
                        <i className="bi bi-check-all"></i>
                      </div>
                      <div className="col-md-8 authentication_n colwidthmobiletwo">
                        <b>Verified Authentications</b>
                      </div>
                      <div className="col-md-2 demapping_ncol colwidthmobilethree">
                        <h4>
                          {summaryLoading ? (
                            <Skeleton animation="wave" />
                          ) : data.verified !== null ? (
                            data.verified
                          ) : (
                            <Skeleton animation="wave" />
                          )}
                        </h4>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-2 damage_iconscol n_issue_ic mt-1 colwidthmobileone">
                        <i className="bi bi-calendar-x"></i>
                      </div>
                      <div className="col-md-8 authentication_n colwidthmobiletwo">
                        <b>Invalid Authentications</b>
                      </div>
                      <div className="col-md-2 damage_ncol colwidthmobileone">
                        <h4>
                          {summaryLoading ? (
                            <Skeleton animation="wave" />
                          ) : data.fake !== null ? (
                            data.fake
                          ) : (
                            <Skeleton animation="wave" />
                          )}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-7">
                <div className="cards firstcard authcountcard1">
                  <div className="row">
                    <div className="col-md-5 align-self-center">
                      <span className="bt_scan">
                        Total:{" "}
                        {!monthlyShipperLoading ? (
                          <span style={{ color: "#ed2225" }}>
                            <b>{totals.TotalPacking}</b>
                          </span>
                        ) : (
                          <span style={{ color: "#ed2225" }}>
                            <b>
                              <Skeleton
                                animation="wave"
                                width={60}
                                style={{
                                  display: "inline-block",
                                  overflow: "unset"
                                }}
                              />
                            </b>
                          </span>
                        )}
                      </span>
                    </div>
                    <div className="col-md-7">
                      <FormControl fullWidth margin="dense">
                        <div className="row">
                          <div className="col-md-4 align-self-center text-right">
                            Plant/Warehouse:
                          </div>
                          <div className="col-md-8">
                            <Dropdown
                              onChange={(e) =>
                                MonthlyPackingCount(e.target.value, brand)
                              }
                              name="warehouseId"
                              options={warehouses}
                              value={warehouseId}
                              optionLabel="label"
                              optionValue="value"
                              placeholder="Select Plant/Warehouse"
                              className="w-full md:w-14rem"
                            />
                          </div>
                        </div>
                      </FormControl>
                    </div>
                  </div>
                  <div className="m_content">
                    {!monthlyShipperLoading ? (
                      <div style={{ height: "150px", margin: "20px" }}>
                        <CanvasJSChart options={chartOptionsPacking} />
                      </div>
                    ) : (
                      <Skeleton
                        animation="wave"
                        width={746}
                        height={190}
                        style={{ margin: "0px 20px" }}
                      />
                    )}
                  </div>
                  <div className="w_authentication_text">
                    <span className="weekly_atxt">
                      <span style={{ color: "#ed2225" }}>Monthly</span> Shipper
                      Scans
                    </span>
                    <br></br>
                    <span className="aut_txt">
                      Shipper Scans over the past months
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="d-flex justify-content-end show_more_show_less"
              style={{ marginRight: "20px" }}
            >
              <button
                onClick={toggleCardVisibility}
                className="btn  show_more_btn"
                style={{
                  background: "none",
                  color: "#ed2625",
                  border: "none",
                  fontWeight: "600",
                  outline: "none"
                }}
              >
                {isCardVisible ? (
                  <>
                    Hide Authentication <i className="fas fa-chevron-up"></i>
                  </>
                ) : (
                  <>
                    Show Authentication <i className="fas fa-chevron-down"></i>
                  </>
                )}
              </button>
              <button
                onClick={toggleUniqueCardVisibility}
                className="btn  show_more_btn"
                style={{
                  background: "none",
                  color: "#ed2625",
                  border: "none",
                  fontWeight: "600",
                  outline: "none"
                }}
              >
                {isUniqueCardVisible ? (
                  <>
                    Hide Unique Authentication <i className="fas fa-chevron-up"></i>
                  </>
                ) : (
                  <>
                    Show Unique Authentication <i className="fas fa-chevron-down"></i>
                  </>
                )}
              </button>
            </div>
            {isCardVisible && (
              <>
                {/* -------- Normal Weekly & Monthly -------- */}
                <div className="row">
                  <div className="col-md-5">
                    <div className="cards firstcard authcountcard1">
                      <div className="w_authentication_text">
                        <span className="weekly_atxt">
                          <span style={{ color: "#ed2225" }}>Weekly</span>{" "}
                          Verified Authentications Summary
                        </span>
                      </div>
                      <div className="row">
                        <div className="col-md-7 align-self-center">
                          <span className="bt_scan">
                            Total:{" "}
                            <span style={{ color: "#ed2225" }}>
                              <b>{totals.TotalWeeklyScans}</b>
                            </span>
                          </span>
                        </div>
                        <div className="col-md-5">
                          <FormControl fullWidth margin="dense">
                            <div className="row">
                              <div className="col-md-4 align-self-center text-right">
                                Region:{" "}
                              </div>
                              <div className="col-md-8">
                                <Dropdown
                                  value={regionIdWeekly}
                                  onChange={(e) =>
                                    weeklyVerificationCount(e.target.value, brand)
                                  }
                                  options={state.regions}
                                  optionLabel="value"
                                  optionValue="id"
                                  name="regionIdWeekly"
                                  placeholder="Select Region"
                                  className="w-full md:w-14rem"
                                />
                              </div>
                            </div>
                          </FormControl>
                        </div>
                      </div>
                      <div className="m_content">
                        <div style={{ height: "150px", margin: "20px" }}>
                          <CanvasJSChart options={chartOptionsweekly} />
                        </div>
                      </div>
                      <div className="w_authentication_text">
                        <span className="weekly_atxt">
                          <span style={{ color: "#ed2225" }}>Verified Authentications</span>
                          {statesWeekly && (
                            <span style={{ display: "block", fontSize: "12px" }}>
                              Included States: {statesWeekly}
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-7">
                    <div className="cards firstcard authcountcard1">
                      <div className="w_authentication_text">
                        <span className="weekly_atxt">
                          <span style={{ color: "#ed2225" }}>Monthly</span>{" "}
                          Verified Authentications Summary
                        </span>
                      </div>
                      <div className="row">
                        <div className="col-md-7 align-self-center">
                          <span className="bt_scan">
                            Total:{" "}
                            <span style={{ color: "#ed2225" }}>
                              <b>{totals.TotalMonthlyScans}</b>
                            </span>
                          </span>
                        </div>
                        <div className="col-md-5">
                          <FormControl fullWidth margin="dense">
                            <div className="row">
                              <div className="col-md-3 align-self-center text-right">
                                Region:{" "}
                              </div>
                              <div className="col-md-9">
                                <Dropdown
                                  value={regionIdMonthly}
                                  onChange={(e) =>
                                    MonthlyVerificationCount(e.target.value, brand)
                                  }
                                  options={state.regions}
                                  optionLabel="value"
                                  optionValue="id"
                                  name="regionIdMonthly"
                                  placeholder="Select Region"
                                  className="w-full md:w-14rem"
                                />
                              </div>
                            </div>
                          </FormControl>
                        </div>
                      </div>
                      <div className="m_content">
                        <div style={{ height: "150px", margin: "20px" }}>
                          <CanvasJSChart options={chartOptionsmonthly} />
                        </div>
                      </div>
                      <div className="w_authentication_text">
                        <span className="weekly_atxt">
                          <span style={{ color: "#ed2225" }}>Verified Authentications</span>
                          {statesMonthly && (
                            <span style={{ display: "block", fontSize: "12px" }}>
                              Included States: {statesMonthly}
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>


              </>
            )}

            {isUniqueCardVisible && (
              <>
                {/* Unique Weekly & Monthly Section */}
                <div className="row">
                  <div className="col-md-5">
                    <div className="cards firstcard authcountcard1">
                      <div className="w_authentication_text">
                        <span className="weekly_atxt">
                          <span style={{ color: "#ed2225" }}>Weekly</span>{" "}
                          Verified Authentications Summary (Unique)
                        </span>
                      </div>
                      <div className="row">
                        <div className="col-md-7 align-self-center">
                          <span className="bt_scan">
                            Total:{" "}
                            <span style={{ color: "#ed2225" }}>
                              <b>{totals.TotalWeeklyScansUnique}</b>
                            </span>
                          </span>
                        </div>
                        <div className="col-md-5">
                          <FormControl fullWidth margin="dense">
                            <div className="row">
                              <div className="col-md-4 align-self-center text-right">
                                Region:{" "}
                              </div>
                              <div className="col-md-8">
                                <Dropdown
                                  value={UniqueregionIdWeekly}
                                  onChange={(e) =>
                                    UniqueweeklyVerificationCount(e.target.value, brand)
                                  }
                                  options={state.regions}
                                  optionLabel="value"
                                  optionValue="id"
                                  name="UniqueregionIdWeekly"
                                  placeholder="Select Region"
                                  className="w-full md:w-14rem"
                                />
                              </div>
                            </div>
                          </FormControl>
                        </div>
                      </div>
                      <div className="m_content">
                        <div style={{ height: "150px", margin: "20px" }}>
                          <CanvasJSChart options={chartUniqueOptionsweekly} />
                        </div>
                      </div>
                      <div className="w_authentication_text">
                        <span className="weekly_atxt">
                          <span style={{ color: "#ed2225" }}>Unique Verified Authentications</span>
                          {statesWeekly && (
                            <span style={{ display: "block", fontSize: "12px" }}>
                              Included States: {statesWeekly}
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-7">
                    <div className="cards firstcard authcountcard1">
                      <div className="w_authentication_text">
                        <span className="weekly_atxt">
                          <span style={{ color: "#ed2225" }}>Monthly</span>{" "}
                          Verified Authentications Summary (Unique)
                        </span>
                      </div>
                      <div className="row">
                        <div className="col-md-7 align-self-center">
                          <span className="bt_scan">
                            Total:{" "}
                            <span style={{ color: "#ed2225" }}>
                              <b>{totals.TotalMonthlyScansUnique}</b>
                            </span>
                          </span>
                        </div>
                        <div className="col-md-5">
                          <FormControl fullWidth margin="dense">
                            <div className="row">
                              <div className="col-md-3 align-self-center text-right">
                                Region:{" "}
                              </div>
                              <div className="col-md-9">
                                <Dropdown
                                  value={UniqueregionIdMonthly}
                                  onChange={(e) =>
                                    UniqueMonthlyVerificationCount(e.target.value, brand)
                                  }
                                  options={state.regions}
                                  optionLabel="value"
                                  optionValue="id"
                                  name="UniqueregionIdMonthly"
                                  placeholder="Select Region"
                                  className="w-full md:w-14rem"
                                />
                              </div>
                            </div>
                          </FormControl>
                        </div>
                      </div>
                      <div className="m_content">
                        <div style={{ height: "150px", margin: "20px" }}>
                          <CanvasJSChart options={chartUniqueOptionsmonthly} />
                        </div>
                      </div>
                      <div className="w_authentication_text">
                        <span className="weekly_atxt">
                          <span style={{ color: "#ed2225" }}>Unique Verified Authentications</span>
                          {statesMonthlyUnique && (
                            <span style={{ display: "block", fontSize: "12px" }}>
                              Included States: {statesMonthlyUnique}
                            </span>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}


            <div className="row">
              <div className="col-md-12">
                <div className="cards chartcard">
                  <div className="row">
                    <div className="col-md-5 align-self-center">
                      <span className="bt_scan mt-4">
                        Total:{" "}
                        <span style={{ color: "#ed2225" }}>
                          <b>{totals.TotalActivations}</b>
                        </span>
                      </span>
                    </div>

                    <div className="col-md-7">
                      <div className="row">
                        <div className="col-md-7"></div>
                        <div className="col-md-5 pr-3">
                          <FormControl fullWidth margin="dense">
                            <Dropdown
                              value={lineTypeId}
                              onChange={(e) => {
                                setlineTypeId(e.target.value);
                                MonthlyActivationCount(
                                  warehouseIdActivation,
                                  productIdActivation,
                                  e.target.value,
                                  brand
                                );
                              }}
                              options={state.lineType}
                              optionLabel="value"
                              optionValue="id"
                              name="lineTypeId"
                              className="w-full md:w-14rem"
                            />
                          </FormControl>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-2 align-self-center text-right">
                          Product SKU:
                        </div>
                        <div className="col-md-4">
                          <FormControl fullWidth margin="dense">
                            <MultiSelect
                              onChange={(e) => {
                                // let selectedIds = [productIdActivation, e.target.value];
                                // selectedIds = selectedIds.flat();
                                // setproductIdActivation(selectedIds);
                                setproductIdActivation(e.target.value);
                                MonthlyActivationCount(
                                  warehouseIdActivation,
                                  e.target.value,
                                  lineTypeId,
                                  brand
                                );
                              }}
                              filter
                              name="productIdActivation"
                              options={products}
                              value={productIdActivation}
                              optionLabel="label"
                              optionValue="id"
                              placeholder="Select Product"
                              className="w-full md:w-14rem"
                            />
                          </FormControl>
                        </div>
                        <div className="col-md-3 align-self-center text-right">
                          Plant/Warehouse:
                        </div>
                        <div className="col-md-3">
                          <FormControl fullWidth margin="dense">
                            <Dropdown
                              onChange={(e) => {
                                setwarehouseIdActivation(e.target.value);
                                MonthlyActivationCount(
                                  e.target.value,
                                  productIdActivation,
                                  lineTypeId,
                                  brand
                                );
                              }}
                              name="warehouseIdActivation"
                              options={warehouses}
                              value={warehouseIdActivation}
                              optionLabel="label"
                              optionValue="value"
                              placeholder="Select Plant/Warehouse"
                              className="w-full md:w-14rem"
                            />
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="mt-3"
                    style={{ height: "160px", margin: "20px" }}
                  >
                    <CanvasJSChart options={chartOptionsActivations} />
                  </div>
                  <div className="w_authentication_text">
                    <span className="weekly_atxt">
                      <span style={{ color: "#ed2225" }}>Product</span>{" "}
                      Activations
                    </span>
                    <br></br>
                    {/* <span className="aut_txt">
                      Activations over the past months
                    </span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default Home;
